import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';
import {MatIconModule} from '@angular/material/icon';
import {SDG_THEMES} from '../../../../models/sdg-themes.data';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-iackathon-step-problematic',
    imports: [
        MatIconModule,
        TranslateModule
    ],
  templateUrl: './iackathon-step-problematic.component.html',
})
export class IackathonStepProblematicComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save()?.attributes.content.state);

    protected readonly themeName = computed(() => this.state()?.sdg_theme_step?.chosen_theme);

    private readonly theme = computed(() => {
        const themeName = this.themeName();

        return SDG_THEMES.find(({name, slug}) => name === themeName || slug === themeName);
    });

    protected readonly themeColor = computed(() => this.theme()?.color);
    protected readonly themeIcon = computed(() => this.theme()?.icon);
    protected readonly hasThemeData = computed(() => Boolean(this.themeName() && this.themeColor() && this.themeIcon()));
    protected readonly problematic = computed(() => this.state()?.problem_step?.problematic);
}
